import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import { GET_DAILYCUSTOMER_FAILED, GET_DAILYCUSTOMER_REQUESTED, GET_DAILYCUSTOMER_SUCCESS, GET_RIDEANALYTIC_FAILED, GET_RIDEANALYTIC_REQUESTED, GET_RIDEANALYTIC_SUCCESS, GET_RIDE_FAILED, GET_RIDE_REQUESTED, GET_RIDE_SUCCESS, GET_TOTALREGISTRATION_FAILED, GET_TOTALREGISTRATION_REQUESTED, GET_TOTALREGISTRATION_SUCCESS } from "resources/actionTypes";
import { dailyCustomerApi, rideAnalyticApi, rideDetailsApi, totalRegistrationApi } from "services/DashboardService";

function* fetchRideDetails(action) {
  try {
    const payload = action.payload || {}
    const userRideDetails = yield call(rideDetailsApi, payload);
    yield put({ type: GET_RIDE_SUCCESS, userRideDetails: userRideDetails });
  } catch (e) {
    yield put({ type: GET_RIDE_FAILED, message: e.message });
    toast.error(e.message || 'Get Ride Details Failed')
  }
}

export function* userRideDetailsSaga() {
  yield takeEvery(GET_RIDE_REQUESTED, fetchRideDetails);
}

function* fetchTotalRegistration(action) {
  try {
    const payload = action.payload || {}
    const userTotalRegistration = yield call(totalRegistrationApi, payload);
    yield put({ type: GET_TOTALREGISTRATION_SUCCESS, userTotalRegistration: userTotalRegistration });
  } catch (e) {
    yield put({ type: GET_TOTALREGISTRATION_FAILED, message: e.message });
    toast.error(e.message || 'Get Total Registration Failed')
  }
}

export function* userTotalRegistrationSaga() {
  yield takeEvery(GET_TOTALREGISTRATION_REQUESTED, fetchTotalRegistration);
}

function* fetchRideAnalytic(action) {
  try {
    const payload = action.payload || {}
    const userRideAnalytic = yield call(rideAnalyticApi, payload);
    yield put({ type: GET_RIDEANALYTIC_SUCCESS, userRideAnalytic: userRideAnalytic });
  } catch (e) {
    yield put({ type: GET_RIDEANALYTIC_FAILED, message: e.message });
    toast.error(e.message || 'Get Ride Analytic Failed')
  }
}

export function* userRideAnalyticSaga() {
  yield takeEvery(GET_RIDEANALYTIC_REQUESTED, fetchRideAnalytic);
}

function* fetchDailyCustomer(action) {
  try {
    const payload = action.payload || {}
    const userDailyCustomer = yield call(dailyCustomerApi, payload);
    yield put({ type: GET_DAILYCUSTOMER_SUCCESS, userDailyCustomer: userDailyCustomer });
  } catch (e) {
    yield put({ type: GET_DAILYCUSTOMER_FAILED, message: e.message });
    toast.error(e.message || 'Get Daily Customer Failed')
  }
}

export function* userDailyCustomerSaga() {
  yield takeEvery(GET_DAILYCUSTOMER_REQUESTED, fetchDailyCustomer);
}